/**
 * Simple helper to check whatver prodided Date instance or string was correct
 * @param {Date|String} date Check if argument given is a valid `Date` instance
 */
export default function isDateValid(date) {
  const value = date instanceof Date ? date : new Date(date);
  return !Number.isNaN(value.getTime());
}
